













































































import * as fb from '@/firebase';
import * as _ from 'lodash';
import store from '@/store';
import VeeValidate from 'vee-validate';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserProfile } from '../models/user-profile';
import { UserModule } from '@/store/modules/user';
import { UserProfileUtil } from '../model-utils/user-profile-util';
// import TrashAccount from '@/components/TrashAccount.vue';
import ErrorWrappedAnything from '@/components/form-elements/ErrorWrappedAnything.vue';
import ErrorWrappedTextInput from '@/components/form-elements/ErrorWrappedTextInput.vue';
import { UploadUtils } from '../utils/upload-utils';

import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import { InviteCode } from '../models/invite-code';
import { InviteCodeModelUtil } from '../model-utils/invite-code-model-util';

const usernameValidator = {
  getMessage(field: any, args: any) {
    return 'Username is already taken';
  },
  validate(value: any, args: any) {
    if (UserModule.username == value) {
      return Promise.resolve(true);
    }

    return fb.usersCollection
      .where('username', '==', value)
      .get()
      .then(querySnapshot => {
        return querySnapshot.empty;
      });
  }
};

@Component({
  components: {
    // TrashAccount,
    ErrorWrappedAnything,
    ErrorWrappedTextInput,
    VueCropper
  }
})
export default class CreateProfile extends Vue {
  public profile: UserProfile = UserProfile.empty();
	@Prop(Boolean) public editMode: boolean;
	@Prop(String) public inviteCode: string;
  photoChanged: boolean = false;
  photoError: string = null;
  cropped: any;
	rotation = 0;
	inviteCodeNotValid: boolean = false;
  public myCroppa = {};

  public uploadCroppedAvatar(): Promise<any> {
    console.log('cropping avatar');
    let resolveFn: () => void = null;
    const promise = new Promise(function(resolve, reject) {
      resolveFn = resolve;
    });
    // @ts-ignore
    this.$refs.cropper.getCroppedCanvas().toBlob(async cropped => {
      console.log('cropped avatar', cropped);
      const downloadURL = await UploadUtils.uploadImageToFirebase(
        cropped,
        'avatars/' +
          Math.random().toString() +
          '-' +
          this.profile.id +
          '-cropped.jpg'
      );
			this.profile.photoURL = downloadURL;
			console.log('got download URL')
      resolveFn();
		}, 'image/jpeg');
		console.log('returning')
		return promise;
  }

  public avatarUpdated(event: Event) {
    this.photoError = '';
    // @ts-ignore
    const file = event.target.files[0];

    var reader = new FileReader();

    const self = this;
    reader.onload = function(event) {
      console.log(self.$refs);
      console.log(self.$refs.cropper);
      // @ts-ignore
      self.$refs.cropper.replace(event.target.result);
    };
    reader.readAsDataURL(file);

    this.photoChanged = true;
    this.photoError = '';
  }

  public created() {
    if (this.editMode) {
      if (UserModule.userProfile) {
        this.profile = _.clone(UserModule.userProfile);
      } else {
        this.$store.watch(
          (state, getters) => state.user.userProfile,
          () => {
            this.profile = _.clone(UserModule.userProfile);
          }
        );
      }
    } else {
			const inviteCode = this.$route.query.inviteCode as string;
      console.log('inviteCode', inviteCode);
      if (!inviteCode) {
        console.log('moving to singupwithcode I hope');
        this.$router.push({
          name: 'SignupWithCode',
          params: { fromCreateProfileString: 'true' }
        });
      } else if (
				!this.editMode &&
				!InviteCodeModelUtil.isValidForCreateProfile(inviteCode)) {
				this.inviteCodeNotValid = true;
			} else {
				const currentUser = fb.auth.currentUser;
				this.profile.displayName = currentUser.displayName;
				this.profile.photoURL = currentUser.photoURL;
				this.profile.joinDate = new Date();
			}
    }

    this.$validator.extend('username-available', usernameValidator);
  }

  public async submit(evt: Event) {
    evt.preventDefault();

    let isValid = await this.$validator.validateAll();

    if (!this.editMode && !this.photoChanged && !this.profile.photoURL) {
      // isValid = false;
      // this.photoError = 'Avatar photo required. Please upload one.';
      const possibleImages = [
        'https://storage.googleapis.com/mixlet.appspot.com/default-user-icons/1.png',
        'https://storage.googleapis.com/mixlet.appspot.com/default-user-icons/2.png',
        'https://storage.googleapis.com/mixlet.appspot.com/default-user-icons/3.png',
        'https://storage.googleapis.com/mixlet.appspot.com/default-user-icons/4.png'
      ];
      this.profile.photoURL = _.sample(possibleImages);
    } else {
      this.photoError = '';
    }

    if (isValid) {
      if (this.photoChanged) {
				console.log('starting upload cropped')
				await this.uploadCroppedAvatar();
				console.log('done upload cropped')
      }

      const inviteCodeString = this.$route.query.inviteCode as string;
      if (!this.editMode && inviteCodeString && inviteCodeString.length > 0 && !this.profile.inviteCodeId) {
				const inviteCode = await InviteCodeModelUtil.findInviteCode(inviteCodeString);
        this.profile.inviteCodeId = inviteCode.id || '';
      }

      fb.usersCollection
        .doc(fb.auth.currentUser.uid)
        .set(this.profile.toFirebaseDoc())
        .then((val: any) => {
          UserModule.setUserProfile(this.profile);
          this.$router.push('/profile');
        });

      this.profile.id = fb.auth.currentUser.uid;

      UserModule.setUserProfile(this.profile);
    }
  }

  get avatar() {
    return this.profile.photoURL || require('@/assets/images/white.png');
  }

  result(output: any) {
    this.cropped = output;
  }

  get initialImage() {
    if (this.profile.photoURL) {
      return this.profile.photoURL;
    } else {
      return require('@/assets/images/upload-avatar.png');
    }
  }

  mounted() {
    //@ts-ignore
    // self.$refs.cropper.replace(this.initialImage);
  }

  clickUploadButton() {
    document.getElementById('photoUpload').click();
  }
}
